import { render } from "./JobsPage.vue?vue&type=template&id=28df10b3"
import script from "./JobsPage.vue?vue&type=script&lang=js"
export * from "./JobsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__